module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main"
  }, [_c('DataTablePage', {
    attrs: {
      "resource": "waterMeter.json",
      "title": "巡查情况",
      "dialogSize": "tiny",
      "relation": false,
      "toolbar": _vm.toolbar,
      "operation": _vm.operation,
      "autoIndex": false,
      "tableFullList": _vm.tableFullList,
      "tableInitList": _vm.tableInitList,
      "filterFullList": _vm.filterFullList,
      "filterInitList": _vm.filterInitList,
      "columns": _vm.columns
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bf3245e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/MeterReading/Patrol/index.vue
// module id = 1772
// module chunks = 1